import React from 'react';
import Div from '../Div';
import './logolist.scss';
const partnerLogos = [
  {
    src: '/images/partners/gnr.png',
    alt: 'GNR',
  },
  {
    src: '/images/partners/prio.png',
    alt: 'Prio',
  },
  {
    src: '/images/partners/finieco.png',
    alt: 'Finieco',
  },
  {
    src: '/images/partners/pcp.png',
    alt: 'Proteção civil logo',
  },
  {
    src: '/images/partners/senvion.png',
    alt: 'Senvion',
  },
  {
    src: '/images/partners/tdportugal.png',
    alt: 'Turismo de Portugal',
  },
];

export default function LogoList() {
  return (
    <Div className="cs-partner_logo_wrap">
      {partnerLogos.map((partnerLogo, index) => (
        <div className="cs-partner_logo" key={index}>
          <img src={partnerLogo.src} alt={partnerLogo.alt} />
        </div>
      ))}
    </Div>
  );
}
